const translations = {
    nameLabel: 'Group name',
    namePlaceholder: 'Enter a name',
    productUsageReportsLabel: 'Product usage reports',
    productUsageReportsPlaceholder: 'Select reports',
    workOrderLabel: 'Work order',
    workOrderPlaceholder: 'Select a work order'
};

export default translations;
